<template>
  <Message
    v-if="notification.show"
    class="position-fixed fixed-top m-0 rounded-0"
    style="z-index: 2000"
    :severity="notification.severity"
    :show="true"
  >
    <span v-safe-html="notification.message"></span>
    Please check our
    <strong>
      <a
        class="alert-link"
        href="https://sundata.statuspage.io"
        target="_blank"
      >
        status page
      </a>
    </strong>
    .
  </Message>
</template>

<style lang="scss">
$notificationHeight: 50px;
#app.hasNotification {
  padding-top: $notificationHeight !important;

  #top-bar {
    top: $notificationHeight !important;
  }
}
</style>

<script lang="ts">
import type { PropType } from 'vue';
import type { StatusNotification } from '@/data/external/StatuspageIoApi.ts';
export default {
  name: 'StatusNotificationBar',
  props: {
    notification: {
      type: Object as PropType<StatusNotification>,
      required: true,
    },
  },
};
</script>
